import React from 'react';
import { TextLG, TextMDRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { Card } from 'styleguide/Card';
import { SecondaryButton } from 'styleguide/Buttons';

interface FolderDetailHevyCTACardProps {
  onCopyUrl: () => void;
}

export const FolderDetailHevyCTACard = (props: FolderDetailHevyCTACardProps) => {
  return (
    <Card style={{ padding: Spacing.lg }}>
      <View style={{ alignItems: 'center' }}>
        <TextLG style={{ paddingBottom: Spacing.sm }}>Save Folder</TextLG>
        <TextMDRegular style={{ paddingBottom: Spacing.md, textAlign: 'center' }} type="secondary">
          To save this Folder and track your workouts, download Hevy for free.
        </TextMDRegular>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: Spacing.md,
          }}
        >
          <a href="https://hevyapp.app.link/8V2C2zMIBNb">
            <DownloadAppstore />
          </a>
          <a href="https://hevyapp.app.link/MrrZGFPIBNb">
            <DownloadGooglePlay />
          </a>
        </View>
      </View>
      <SecondaryButton title="Copy Link to Folder" onClick={props.onCopyUrl} iconType={'link'} />
    </Card>
  );
};
